import moment from "moment";

export const formatTime = (timestamp) => {
  const time = timestamp ? moment(timestamp) : moment();
  if (time.minute() === 0) return time.format("ddd h A");
  else return time.format("ddd h:mm A");
};
